import Icon, { type IconName } from 'components/Icon';
import { LayoutContainer } from 'components/Layout';
import Text from 'components/Text';
import type { Field, HeadingLevel } from 'models/sitecore';
import type { HTMLAttributes } from 'types';

interface Props extends HTMLAttributes<HTMLDivElement> {
	className?: string;
	description: Field<string> | undefined;
	heading: Field<string> | undefined;
	headingIcon: IconName | undefined;
	headingLevel: HeadingLevel | undefined;
}

export default function ContactHeading({
	className,
	description,
	heading,
	headingIcon,
	headingLevel,
	...attrs
}: Props) {
	return (
		<LayoutContainer {...attrs} outerClassName={className}>
			<div className="max-w-col-6 border-t border-t-strong pt-r-lg">
				<div className="flex items-center">
					{headingIcon && <Icon name={headingIcon} className="mr-2 shrink-0" />}
					<Text as={headingLevel || 'h2'} field={heading} />
				</div>
				{description && <Text as="p" field={description} className="mt-4" />}
			</div>
		</LayoutContainer>
	);
}
ContactHeading.displayName = 'ContactHeading';
